module.exports = __webpack_public_path__ + "img/active-4.e9dc82b2.png";